export default {
    colors: {
      primary: "#31b668",
      text: "#696d71",
      white: "#ffffff",
    },
  };
  